import { apiRequest } from './api';

export const getSessions = () =>
  apiRequest('GET', '/sessions');

export const getSession = (id: string) =>
  apiRequest('GET', `/sessions/${id}`);

export const createSession = (data: any) =>
  apiRequest('POST', '/sessions', data);

export const updateSession = (id: string, data: any) =>
  apiRequest('PUT', `/sessions/${id}`, data);

export const getSessionsForUser = (userId: string) =>
  apiRequest('GET', `/sessions/user/${userId}`);

export const getActivityStatisticsForUser = (userId: string, activityName: string) =>
  apiRequest('GET', `/sessions/statistics/${userId}?activityName=${activityName}`);

export const getAllStatistics = (query: string) =>
  apiRequest('GET', `/sessions/statistics/all?${query}`);

export const getAllStatisticsMulti = (queries: string[]) =>
  apiRequest('POST', `/sessions/statistics/all`, { queries });


// Console accessible debug methods available in development mode
if (process.env.NODE_ENV === 'development') {
  window.getSessions = getSessions;
  window.getSession = getSession;
  window.createSession = createSession;
  window.updateSession = updateSession;
  window.getSessionsForUser = getSessionsForUser;
  window.getActivityStatisticsForUser = getActivityStatisticsForUser;
  window.getAllStatistics = getAllStatistics;
  window.getAllStatisticsMulti = getAllStatisticsMulti;
}